export const Api = 'http://api.newgroundworld.com'
export const AuthToken = localStorage.getItem('token') || null


// WEBPACK FOOTER //
// ./src/modules/consts.js